import Swiper, { EffectFade } from 'swiper';

const init = () => {
  const slider = document.querySelector('.js-approach-slider');
  const slideNavButtons = document.querySelectorAll('.js-slide-nav');
  const currentSlideEl = document.querySelector('.js-current-slide');
  const nextButtons = document.querySelectorAll('.js-approach-next');
  const prevButtons = document.querySelectorAll('.js-approach-prev');

  if (!slider || !slideNavButtons.length) return;

  const swiper = new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 600,
    loop: false,
    allowTouchMove: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    modules: [EffectFade],
  });

  const scrollToActiveButton = (activeIndex) => {
    const activeButton = slideNavButtons[activeIndex];
    if (!activeButton) return;

    const scrollContainer = activeButton.closest('[style*="overflow"]')
                           || activeButton.closest('.overflow-scroll')
                           || activeButton.closest('.overflow-x-scroll')
                           || activeButton.closest('.overflow-auto')
                           || activeButton.closest('.overflow-x-auto')
                           || activeButton.parentElement;

    if (scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const buttonRect = activeButton.getBoundingClientRect();

      if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
        activeButton.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  };

  const updateNavigation = (activeIndex) => {
    slideNavButtons.forEach((btn, index) => {
      btn.classList.toggle('approach-slide-nav--active', index === activeIndex);
    });

    if (currentSlideEl) {
      currentSlideEl.textContent = String(activeIndex + 1).padStart(2, '0');
    }

    scrollToActiveButton(activeIndex);
  };

  slideNavButtons.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      swiper.slideTo(index);
      updateNavigation(index);
    });
  });

  nextButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const currentIndex = swiper.activeIndex;
      if (currentIndex < swiper.slides.length - 1) {
        swiper.slideTo(currentIndex + 1);
        updateNavigation(currentIndex + 1);
      } else {
        swiper.slideTo(0);
        updateNavigation(0);
      }
    });
  });
  prevButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const currentIndex = swiper.activeIndex;
      if (currentIndex > 0) {
        swiper.slideTo(currentIndex - 1);
        updateNavigation(currentIndex - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
        updateNavigation(swiper.slides.length - 1);
      }
    });
  });

  swiper.on('slideChange', () => {
    updateNavigation(swiper.activeIndex);
  });

  updateNavigation(0);
};

export default {
  init,
};
